import React from 'react';
import './Footer.css';

const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;

export default function Footer() {
  return (
    <footer className="tp-footer">
      <div className="container tp-footer__inner">
        <nav className="tp-footer__links body-s">
          <a href="{{TERMS_URL}}">Terms</a>
          <a href="{{REFUND_POLICY_URL}}">Refund policy</a>
          <a href="https://www.withfaye.com/privacy-policy">Privacy</a>
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </nav>
        <p className="body-s tp-footer__disclaimer">
          Travel+ is a separate product from your Faye travel insurance policy. Lounge access and eSIM are provided with third-party partners. Always subject to applicable terms and conditions.
        </p>
      </div>
    </footer>
  );
}
